{
  "fleet": {
    "ai": {
      "title": "GeoPoint AI",
      "description": "Cómo está configurado GeoPoint AI, quién puede usarlo, qué preguntan y cuánto cuesta.",
      "tab": {
        "settings": "Ajustes",
        "access": "Acceso",
        "conversations": "Conversaciones",
        "insights": "Análisis"
      }
    },
    "aiInsights": {
      "from": "Desde",
      "to": "Hasta",
      "show": "Mostrar",
      "questions": "Preguntas",
      "cost": "Coste",
      "errors": "Errores",
      "errorRate": "Tasa de errores",
      "errorsHint": "Errores: {{n}}",
      "fallbackRate": "Tasa de respaldo",
      "avgTime": "Tiempo medio de respuesta",
      "p95Time": "Tiempo percentil 95",
      "cacheHitRate": "Aciertos de caché",
      "cacheHint": "tokens en caché ÷ de entrada",
      "questionsPerDay": "Preguntas por día",
      "costPerDay": "Coste por día",
      "tokensPerDay": "Tokens por día (entrada + salida)",
      "byAccount": "Por cuenta",
      "tools": "Herramientas más usadas",
      "tool": "Herramienta",
      "calls": "Llamadas",
      "failingTools": "Herramientas que más fallan",
      "noFailingTools": "Ninguna herramienta falló en este intervalo.",
      "failShare": "{{errors}} de {{calls}} · {{percent}}",
      "refreshing": "Actualizando…",
      "problem": {
        "from": "Elige un primer día.",
        "to": "Elige un último día.",
        "order": "El último día es anterior al primero.",
        "span": "Elige un intervalo de {{max}} días como máximo."
      },
      "feedbackPerDay": "👍 / 👎 por día",
      "day": "Día",
      "noFeedback": "Ninguna respuesta fue valorada en este periodo.",
      "openDown": "Abrir las conversaciones con un 👎"
    },
    "aiFailed": {
      "title": "Pregunta fallida",
      "question": "Pregunta",
      "partial": "Respuesta parcial",
      "noPartial": "No se respondió nada antes del fallo.",
      "error": "Error",
      "openConversation": "Abrir la conversación",
      "noConversation": "Falló antes de que existiera una conversación, así que el usuario no la tiene en su historial."
    },
    "aiConversation": {
      "back": "Conversaciones",
      "title": "Conversación",
      "meta": "{{account}} · iniciada {{when}}",
      "audited": "La apertura quedó registrada en Actividad.",
      "openAccount": "Abrir la cuenta",
      "user": "Pregunta",
      "assistant": "GeoPoint AI",
      "turnError": "Fallida",
      "timeline": "Cronología",
      "nextAttempt": "Siguiente intento",
      "toolCall": "Llamada a herramienta: {{name}}",
      "toolInput": "Entrada",
      "toolOutput": "Salida",
      "showAll": "Mostrar todo ({{count}} caracteres)",
      "turnsWithoutAnswer": "Turnos sin respuesta",
      "failedQuestions": "Preguntas fallidas",
      "rating": {
        "up": "Buena respuesta",
        "down": "Mala respuesta"
      }
    },
    "aiConversations": {
      "account": "Cuenta",
      "anyAccount": "Todas las cuentas",
      "deletedAccount": "Cuenta eliminada #{{id}}",
      "from": "Desde",
      "to": "Hasta",
      "tool": "Herramienta",
      "anyTool": "Cualquier herramienta",
      "all": "Todas",
      "failed": "Fallidas",
      "slow": "Lentas",
      "slowNote": "Lentas se aplica a las conversaciones cargadas hasta ahora.",
      "slowHint": "Conversaciones (tiempo total de todas las respuestas) o preguntas fallidas de un minuto o más, entre las cargadas",
      "none": "Ninguna conversación coincide con estos filtros.",
      "more": "Cargar más",
      "fallback": "respaldo",
      "ok": "OK",
      "errors": "Errores: {{n}}",
      "tokensTitle": "entrada {{input}} · en caché {{cached}} · salida {{output}} · razonamiento {{reasoning}}",
      "col": {
        "when": "Cuándo",
        "account": "Cuenta",
        "question": "Pregunta",
        "turns": "Turnos",
        "tokens": "Tokens entrada / caché / salida / razonamiento",
        "cost": "Coste",
        "model": "Modelo",
        "duration": "Tiempo",
        "status": "Estado",
        "rating": "Valoraciones"
      },
      "errorKind": {
        "timeout": "Tiempo agotado",
        "provider": "Error del proveedor",
        "tools": "Error de herramienta",
        "aborted": "Detenida",
        "other": "Error"
      },
      "down": "Malas respuestas",
      "downHint": "Conversaciones con al menos un 👎 (las preguntas fallidas no se muestran)",
      "ratingTitle": "👍 {{up}} · 👎 {{down}}"
    },
    "aiAccess": {
      "searchPlaceholder": "Nombre, correo o número de cuenta…",
      "hint": "Un límite vacío significa el predeterminado de Ajustes. El interruptor guarda al instante; el límite se guarda con su botón.",
      "deleted": "Cuenta eliminada #{{id}}",
      "chip": {
        "all": "Todas",
        "on": "Activadas",
        "off": "Desactivadas",
        "deleted": "Cuentas eliminadas"
      },
      "col": {
        "account": "Cuenta",
        "access": "Acceso y límite diario",
        "today": "Hoy",
        "month": "Este mes",
        "cost": "Coste este mes"
      },
      "customersHint": "Las cuentas se agrupan por cliente: un gestor y las cuentas que gestiona, o una cuenta independiente. El modelo y el presupuesto mensual de un cliente se aplican a todas sus cuentas; vacío = la configuración global y sin presupuesto propio."
    },
    "aiSettings": {
      "changedElsewhere": "Los ajustes se cambiaron en otro sitio. Recarga para verlos; se perderían tus cambios sin guardar.",
      "reload": "Recargar",
      "noKeyWarning": "{{providers}} se quedará sin clave tras guardar, así que GeoPoint AI no podrá responder con él.",
      "spend": "Gasto de este mes",
      "ofCap": "del límite de {{cap}} · {{percent}}",
      "noCap": "sin límite mensual",
      "routing": "Modelos y límites",
      "primary": "Principal",
      "fallback": "Respaldo",
      "noFallback": "Sin respaldo",
      "monthlyCap": "Límite mensual (USD)",
      "defaultDailyLimit": "Preguntas por cuenta y día",
      "invalid": "Revisa los campos marcados.",
      "keySaved": "Clave guardada, termina en {{last4}}",
      "keyNone": "Sin clave",
      "keyRemoving": "La clave se eliminará al guardar.",
      "newKey": "Clave nueva",
      "check": "Comprobar la clave guardada",
      "removeKey": "Eliminar clave",
      "keepKey": "Conservar clave",
      "model": "Modelo",
      "modelNoPrice": "GeoPoint AI no tiene precio para este modelo, así que no podría seguir su coste. Modelos con precio: {{models}}",
      "effort": "Razonamiento",
      "effortLevel": {
        "minimal": "Mínimo",
        "low": "Bajo",
        "medium": "Medio",
        "high": "Alto"
      },
      "note": {
        "xai": "Activa Zero Data Retention para el equipo de xAI al que pertenece la clave.",
        "google": "La clave de Gemini debe pertenecer a un proyecto de pago (facturación activada); el nivel gratuito usa los datos para entrenar.",
        "anthropic": "Crea la clave en la consola de Anthropic, en la organización que paga."
      },
      "models": {
        "title": "Modelos (últimos 30 días)",
        "provider": "Proveedor",
        "questions": "Preguntas",
        "avg": "Tiempo medio",
        "p90": "Percentil 90",
        "perQuestion": "Por pregunta",
        "none": "Ninguna pregunta en los últimos 30 días."
      }
    },
    "ledger": {
      "title": "Registro y estado",
      "description": "El registro de trayectos detrás de cada informe, y si los localizadores y Traccar están sanos.",
      "tabLedger": "Registro",
      "tabHealth": "Estado",
      "status": "Registro",
      "running": "Reconstruyendo",
      "idle": "En reposo",
      "since": "Cubre todos los días desde el {{day}}",
      "noStart": "Sin día de inicio",
      "progress": "{{done}} de {{total}} hechos · {{percent}}",
      "coverage": "Cobertura",
      "coverageHint": "Los días que el registro tiene guardados para cada vehículo. Una celda verde rellena es un día guardado; una celda con borde y una línea diagonal es un día que falta.",
      "cellBuilt": "{{day}}: guardado",
      "cellMissing": "{{day}}: falta",
      "show": "Mostrar",
      "from": "Desde",
      "to": "Hasta",
      "noCoverage": "No hay días guardados en este intervalo.",
      "built": "guardado",
      "missing": "falta",
      "missingCount": "{{n}} faltan",
      "rebuild": "Reconstruir",
      "rebuildHint": "Recalcula los trayectos y los totales de informes de un vehículo para un máximo de {{max}} días. Solo se ejecuta una reconstrucción a la vez.",
      "vehicle": "Vehículo",
      "rebuildButton": "Reconstruir…",
      "problem": {
        "from": "Elige un día de inicio.",
        "to": "Elige un día final.",
        "order": "El día final es anterior al de inicio.",
        "span": "Como máximo {{max}} días a la vez.",
        "future": "Hoy aún no se guarda. Elige ayer o antes.",
        "beforeStart": "El registro empieza después de ese día."
      },
      "confirmTitle": "¿Reconstruir {{name}}?",
      "confirmBody": "Los trayectos y los totales de informes del {{from}} al {{to}} ({{n}} días) se recalculan a partir de las posiciones guardadas, así que los informes de esos días pueden cambiar. El progreso se muestra aquí mientras se ejecuta.",
      "confirm": "Reconstruir",
      "switchedOff": "El registro está desactivado en este Traccar, así que no se puede reconstruir nada.",
      "vehicleHint": "Solo aparecen los vehículos que han informado."
    },
    "health": {
      "silent": "Localizadores sin datos",
      "silentWeek": "Más de 7 días",
      "silentDay": "De 24 horas a 7 días",
      "noneSilent": "Todos los localizadores enviaron datos en las últimas 24 horas.",
      "dataUsage": "Uso de datos por vehículo",
      "dataUsageOf": "Datos por día — {{name}}",
      "vehicle": "Vehículo",
      "perDay": "Por día",
      "total": "Total",
      "statistics": "Estadísticas diarias de Traccar",
      "messagesReceived": "Mensajes recibidos",
      "messagesStored": "Mensajes guardados",
      "activeDevices": "Dispositivos activos",
      "day": "Día"
    },
    "groups": {
      "tab": "Grupos",
      "title": "Grupos",
      "description": "Grupos de vehículos y las cuentas que ven cada grupo.",
      "searchPlaceholder": "Nombre del grupo…",
      "col": {
        "name": "Grupo",
        "vehicles": "Vehículos",
        "accounts": "Cuentas"
      },
      "detail": {
        "title": "Grupo",
        "vehicles": "Vehículos de este grupo",
        "accounts": "Cuentas que ven este grupo",
        "moveIn": "Mover aquí",
        "moveOut": "Quitar del grupo",
        "inGroup": "ahora en {{name}}",
        "moveHint": "Mover un vehículo aquí lo saca del grupo en el que está ahora."
      }
    },
    "zones": {
      "tab": "Zonas",
      "title": "Zonas",
      "description": "Todas las zonas dibujadas en traccar-web, aquí solo de lectura, y con quién se comparte cada una.",
      "searchPlaceholder": "Nombre de la zona…",
      "none": "Aún no hay zonas",
      "sharedWith": "Compartida con:",
      "sharedWithNobody": "nadie",
      "groupName": "grupo {{name}}",
      "shape": {
        "circle": "Círculo",
        "polygon": "Área",
        "line": "Ruta",
        "unknown": "No se puede dibujar"
      }
    },
    "vehicles": {
      "title": "Vehículos y localizadores",
      "description": "Cada vehículo y su localizador: si está enviando datos, sus límites y contadores, y quién lo ve.",
      "searchPlaceholder": "Matrícula, IMEI, modelo o grupo…",
      "noGroup": "Sin grupo",
      "noLimit": "Sin límite",
      "ago": "hace {{age}}",
      "never": "nunca",
      "card": {
        "total": "Vehículos",
        "online": "En línea ahora",
        "silent": "Sin datos > 24 h",
        "noFix": "Sin posición hoy",
        "dataToday": "Datos hoy"
      },
      "chip": {
        "all": "Todos",
        "online": "En línea",
        "silent": "Sin datos > 24 h",
        "noFix": "Sin posición hoy",
        "noGroup": "Sin grupo"
      },
      "col": {
        "name": "Vehículo",
        "group": "Grupo",
        "status": "Último registro",
        "speedLimit": "Límite de velocidad",
        "fuel": "Combustible",
        "odometer": "Odómetro",
        "accounts": "Cuentas",
        "data7d": "Datos 7 días"
      },
      "status": {
        "online": "En línea",
        "offline": "Desconectado",
        "unknown": "Desconocido"
      },
      "fuel": {
        "trusted": "Fiable",
        "approx": "Aproximado",
        "none": "Sin datos de combustible",
        "unset": "Sin definir"
      },
      "detail": {
        "title": "Vehículo",
        "settings": "Ajustes",
        "speedLimit": "Límite de velocidad (km/h)",
        "speedLimitHint": "{{min}}–{{max}} km/h, o vacío para sin límite.",
        "fuelQuality": "Calidad del combustible",
        "fuelHint": "Cuánto pueden fiarse GeoPoint AI y los informes de las lecturas de combustible de este vehículo.",
        "accumulators": "Odómetro y horas de motor",
        "odometer": "Odómetro (km)",
        "hours": "Horas de motor (h)",
        "now": "Ahora {{value}}",
        "accumulatorsInvalid": "Usa un número de 0 o más.",
        "accumulatorsSave": "Cambiar…",
        "accumulatorsConfirmTitle": "¿Cambiar los contadores de {{name}}?",
        "accumulatorsConfirmBody": "Los totales de los informes futuros cambian: la distancia y las horas de motor siguen contando desde los nuevos valores. Los informes ya enviados conservan lo que mostraban.",
        "accumulatorsConfirm": "Cambiar contadores",
        "changeLine": "{{field}}: {{from}} → {{to}}",
        "accumulatorsCanNote": "En vehículos con odómetro CAN los informes leen el odómetro propio del vehículo, así que este cambio puede no modificar el odómetro de los informes.",
        "noRecordYet": "Este vehículo aún no ha enviado ningún registro, así que sus contadores no se pueden cambiar.",
        "group": "Grupo",
        "move": "Mover",
        "lastFix": "Última posición",
        "lastRecords": "Últimos registros recibidos",
        "noRecords": "Aún no se ha recibido ningún registro.",
        "fixTime": "Hora de posición",
        "position": "Posición",
        "speed": "Velocidad",
        "fix": "Posición",
        "valid": "válida",
        "invalid": "no válida",
        "accounts": "Cuentas que lo ven"
      }
    },
    "accounts": {
      "title": "Cuentas",
      "description": "Todas las cuentas de Traccar: quién puede entrar, qué ve y si usa GeoPoint AI.",
      "searchPlaceholder": "Nombre o correo…",
      "on": "Activada",
      "off": "Desactivada",
      "noExpiry": "No caduca",
      "questionsToday": "{{n}} hoy",
      "card": {
        "total": "Cuentas",
        "disabled": "Desactivadas",
        "admins": "Administradores y gestores",
        "milo": "GeoPoint AI activado"
      },
      "chip": {
        "all": "Todas",
        "on": "Activadas",
        "off": "Desactivadas",
        "admins": "Administradores y gestores",
        "milo": "GeoPoint AI activado"
      },
      "col": {
        "name": "Nombre",
        "role": "Rol",
        "vehicles": "Vehículos",
        "groups": "Grupos",
        "status": "Cuenta",
        "expiry": "Caduca",
        "milo": "GeoPoint AI"
      },
      "role": {
        "admin": "Administrador",
        "manager": "Gestor",
        "user": "Usuario",
        "readonly": "Solo lectura"
      },
      "detail": {
        "title": "Cuenta",
        "vehicles": "Vehículos",
        "groups": "Grupos",
        "access": "Acceso",
        "accountSwitch": "Cuenta activada",
        "miloSwitch": "GeoPoint AI activado",
        "dailyLimit": "Preguntas por día",
        "dailyLimitDefault": "predeterminado",
        "dailyLimitInvalid": "Un número entero hasta 1000, o vacío para el valor predeterminado.",
        "conversations": "Conversaciones",
        "offTitle": "¿Desactivar {{name}}?",
        "offBody": "No podrá entrar en traccar-web ni en la app, y sus informes y alertas dejarán de llegarle, hasta que la cuenta se active de nuevo.",
        "offConfirm": "Desactivar",
        "serviceAccount": "La cuenta de Traccar del propio echo: desactivarla dejaría la administración de flota sin acceso a Traccar. Cámbiala en traccar-web si de verdad hace falta."
      }
    },
    "sims": {
      "title": "Datos SIM",
      "description": "Lo que 1NCE factura por cada SIM de los localizadores, día a día, y cuánto le queda de su cuota.",
      "syncNow": "Sincronizar ahora",
      "syncing": "Sincronizando…",
      "live": "En vivo",
      "liveAt": "En vivo · {{time}}",
      "lastRun": "Última sincronización {{when}} · {{status}} · {{count}} SIM",
      "neverRun": "Aún sin sincronizar. La primera sincronización trae el historial de cada SIM.",
      "running": "Sincronizando…",
      "status": {
        "ok": "correcta",
        "partial": "parcial",
        "failed": "fallida",
        "running": "en curso"
      },
      "openSince": "Abierta desde {{when}}: aún sin facturar",
      "closed": "Cerrada {{when}}",
      "unknownSession": "—",
      "lastError": "La última consulta falló: {{error}}",
      "days": {
        "day": "Día",
        "volume": "Usado",
        "sent": "Enviado",
        "received": "Recibido",
        "state": "Estado",
        "empty": "No hay días en este periodo."
      },
      "state": {
        "confirmed": "Confirmado",
        "checking": "En revisión",
        "changed": "{{change}} al revisar"
      },
      "summary": {
        "used": "Usado en {{period}}: {{used}}",
        "perVehicle": "Por vehículo y día: {{value}}",
        "low": "Con menos del 20 %: {{count}}",
        "open": "Sin facturar aún: {{count}}"
      },
      "card": {
        "leftOf": "restantes de {{total}}",
        "lasts": "Dura hasta ≈ {{year}}, más allá del vencimiento de la SIM ({{expiry}})",
        "runsOut": "Se agota ≈ {{year}}, antes de que venza la SIM ({{expiry}})",
        "lastsNoExpiry": "Dura hasta ≈ {{year}}",
        "noEstimate": "Sin uso reciente para estimar",
        "used": "{{used}} en {{period}}, {{perDay}} al día",
        "bars": "Datos por día: {{name}}",
        "notFinal": "no definitivo",
        "open": "Abrir la SIM de {{name}}",
        "details": "Detalles"
      },
      "noVehicles": "Ninguna SIM está aún en un vehículo.",
      "spares": "SIM de reserva, sin vehículo: {{count}}",
      "spareLeft": "{{left}} de {{total}} restantes",
      "by": {
        "day": "Días",
        "week": "Semanas",
        "month": "Meses"
      },
      "periods": {
        "day": "los últimos 30 días",
        "week": "las últimas 12 semanas",
        "month": "los últimos 12 meses"
      },
      "panel": {
        "phone": "Número de teléfono",
        "phoneHint": "Los comandos SMS al localizador van a este número",
        "imei": "IMEI del equipo",
        "imsi": "IMSI",
        "iccid": "ICCID",
        "ip": "Dirección IP",
        "status": "Estado",
        "activated": "Activada",
        "validUntil": "Válida hasta",
        "left": "Datos restantes",
        "leftOf": "{{left}} de {{total}}",
        "session": "Sesión",
        "usage": "Uso",
        "week": "Semana",
        "month": "Mes",
        "weekOf": "Semana del {{date}}"
      },
      "heatmap": {
        "title": "Uso por vehículo",
        "vehicle": "Vehículo",
        "total": "Total",
        "cell": "{{name}}, {{period}}: {{value}}",
        "noData": "sin datos",
        "zero": "0",
        "upTo": "hasta {{value}}"
      }
    },
    "nav": {
      "title": "Administración de flota",
      "accounts": "Cuentas",
      "vehicles": "Vehículos",
      "groups": "Grupos y zonas",
      "ledger": "Registro y estado",
      "sims": "Datos SIM",
      "ai": "GeoPoint AI"
    },
    "common": {
      "eyebrow": "Administración de flota",
      "timesIn": "Todas las horas en {{tz}}",
      "unavailable": "no disponible",
      "unavailableHint": "No se pudo cargar ahora",
      "loading": "Cargando…",
      "retry": "Reintentar",
      "readOnly": "Se muestran los últimos datos leídos. Los cambios están en pausa hasta que vuelva la conexión.",
      "openInTraccar": "Abrir en traccar-web",
      "search": "Buscar",
      "cancel": "Cancelar",
      "save": "Guardar",
      "saving": "Guardando…",
      "on": "Activado",
      "off": "Desactivado",
      "none": "Ninguno",
      "all": "Todos",
      "noMatch": "Nada coincide con “{{query}}”",
      "noMatchHint": "Prueba con un nombre, una matrícula, un correo o un IMEI.",
      "empty": "Aún no hay nada aquí",
      "link": "Vincular",
      "unlink": "Desvincular",
      "locked": "Bloqueado",
      "nothingToLink": "Nada más que vincular",
      "lockedWhy": "la cuenta de servicio propia de echo",
      "pick": "Elegir…",
      "noneLinked": "Nada vinculado",
      "back": "Volver"
    },
    "errors": {
      "traccar_not_connected": "Traccar aún no está conectado a echo.",
      "traccar_unavailable": "Traccar no responde. Se muestran los últimos datos leídos; vuelve a intentarlo en un minuto.",
      "traccar_auth": "Traccar rechazó el token de echo. La conexión con Traccar necesita un token nuevo.",
      "milo_not_connected": "GeoPoint AI no está conectado a echo: falta su dirección o su token de administrador, o no son aceptados.",
      "milo_unavailable": "GeoPoint AI no responde. Vuelve a intentarlo en un minuto.",
      "not_found": "Ya no existe. La lista se ha actualizado.",
      "validation": "Algunos valores no se aceptaron. Revisa el formulario y vuelve a intentarlo.",
      "rebuild_running": "Ya hay una reconstrucción en curso. Inténtalo de nuevo cuando termine.",
      "once_not_connected": "Los datos de las SIM aún no están conectados a echo: falta la clave API de 1NCE.",
      "once_unavailable": "1NCE no responde. Se muestran las cifras de la última sincronización; vuelve a intentarlo en un minuto.",
      "once_auth": "1NCE rechazó la clave API de echo. La conexión con 1NCE necesita una clave nueva.",
      "sync_running": "Ya hay una sincronización de SIM en curso. Sus cifras aparecerán cuando termine.",
      "network": "No se puede conectar con echo. Revisa tu conexión y vuelve a intentarlo.",
      "unknown": "Algo salió mal. Vuelve a intentarlo."
    },
    "warnings": {
      "title": "Algunas partes no se pudieron cargar",
      "parts": "Falta: {{parts}}",
      "part": {
        "accounts": "nombres de cuentas",
        "links": "vínculos entre cuentas, vehículos y grupos",
        "groups": "nombres de grupos",
        "devices": "nombres de vehículos",
        "positions": "últimos registros",
        "dataUsage": "uso de datos",
        "milo": "GeoPoint AI",
        "ledgerStatus": "estado del registro",
        "ledgerCoverage": "cobertura del registro",
        "statistics": "estadísticas de Traccar",
        "zoneSharing": "uso compartido de zonas",
        "customers": "clientes (cada cuenta se muestra como su propio cliente)"
      }
    },
    "notConnected": {
      "traccarTitle": "Traccar no está conectado",
      "traccarBody": "echo necesita TRACCAR_URL y TRACCAR_SERVICE_TOKEN (el token de la cuenta de administrador de Traccar echo-service). Configura ambos en el entorno de echo y reinicia echo.",
      "miloTitle": "GeoPoint AI no está conectado",
      "miloBody": "echo necesita MILO_URL y MILO_ADMIN_TOKEN, y Milo el mismo MILO_ADMIN_TOKEN. Configúralos y reinicia ambos servicios.",
      "onceTitle": "Los datos SIM no están conectados",
      "onceBody": "echo necesita ONCE_CLIENT_ID y ONCE_CLIENT_SECRET (una clave de la API de gestión de 1NCE). Configura ambas en el entorno de echo y reinicia echo."
    },
    "aiCustomers": {
      "unknown": "Cliente #{{id}}",
      "deleted": "Cliente eliminado #{{id}}",
      "members": "Cuentas: {{n}} · GeoPoint AI activado: {{enabled}}",
      "provider": "Modelo del cliente",
      "model": "Modelo",
      "budget": "Presupuesto mensual (USD)",
      "noBudget": "Sin presupuesto",
      "globalModel": "Modelo global",
      "globalModelIs": "Modelo global ({{model}} · {{effort}})",
      "noKey": "{{provider}} (sin clave)",
      "spendOfBudget": "{{spent}} de {{budget}} · {{percent}}",
      "spendNoBudget": "{{spent}} este mes · sin presupuesto propio",
      "questions": "Preguntas este mes: {{n}}",
      "noLonger": "Esta cuenta ya no es un cliente (ahora la gestiona otra cuenta): su modelo y presupuesto no se aplican.",
      "state": {
        "near": "Cerca del presupuesto",
        "reached": "Presupuesto agotado: en pausa hasta fin de mes"
      },
      "invalid": {
        "provider": "{{provider}} no tiene clave, así que este cliente usa el modelo global. Elige otro modelo o el global.",
        "model": "GeoPoint AI no tiene precio para este modelo. Elige uno con precio.",
        "effort": "Elige un nivel de razonamiento.",
        "budget": "El presupuesto es un importe en USD de 0 a 100.000; vacío = sin presupuesto propio."
      },
      "lock": {
        "customers": "No se pudieron cargar los clientes; los modelos y presupuestos no se pueden cambiar ahora.",
        "unknown": "Este cliente aún no está en la lista de clientes. Recarga para cambiarlo.",
        "deleted": "La cuenta de este cliente ya no existe; su configuración ya no se aplica.",
        "settings": "La configuración de GeoPoint AI no está cargada; no se puede elegir un modelo."
      },
      "noMembers": "Sin cuentas"
    }
  },
  "error500": {
    "title": "500 Error del Servidor",
    "subtitle": "Algo salió mal de nuestro lado",
    "description": "Pedimos disculpas por las molestias. El servidor encontró un error interno y no pudo completar su solicitud. Nuestro equipo ha sido notificado.",
    "tryAgain": "Intentar de nuevo",
    "goHome": "Ir a Inicio",
    "errorCode": "Código de error"
  },
  "sidebar": {
    "title": "Barra Lateral",
    "mobileDescription": "Muestra la barra lateral móvil.",
    "toggle": "Alternar Barra Lateral"
  },
  "nav": {
    "board": "Tablero",
    "planner": "Planificador",
    "map": "Mapa en vivo",
    "exceptions": "Incidencias",
    "documents": "Documentos",
    "buyers": "Clientes",
    "fleet": "Flota",
    "billing": "Facturación",
    "outbox": "Enviados",
    "roadmap": "Hoja de ruta",
    "dashboard": "Panel",
    "counters": "Contadores",
    "users": "Usuarios",
    "activityHistory": "Actividad",
    "profile": "Perfil",
    "settings": "Ajustes",
    "collapse": "Colapsar",
    "demo": "Demo",
    "logout": "Cerrar sesión",
    "section": {
      "dispatch": "Expedición",
      "book": "Registro",
      "admin": "Administración"
    }
  },
  "theme": {
    "light": "Claro",
    "dark": "Oscuro",
    "system": "Sistema"
  },
  "language": {
    "en": "English",
    "es": "Español",
    "sr": "Српски"
  },
  "common": {
    "user": "Usuario",
    "cancel": "Cancelar",
    "save": "Guardar",
    "dismiss": "Cerrar"
  },
  "login": {
    "title": "Bienvenido de nuevo",
    "description": "Ingresa tus credenciales para iniciar sesión en tu cuenta",
    "identifier": {
      "username": "Nombre de usuario",
      "email": "Correo electrónico",
      "both": "Nombre de usuario o correo electrónico",
      "placeholder": "Ingresa tu {{field}}"
    },
    "password": {
      "label": "Contraseña",
      "placeholder": "Ingresa tu contraseña"
    },
    "button": "Iniciar sesión",
    "button.loading": "Iniciando sesión...",
    "error": {
      "identifierRequired": "{{field}} es obligatorio",
      "passwordLength": "La contraseña debe tener al menos 6 caracteres",
      "failed": "Error al iniciar sesión",
      "unknown": "Ocurrió un error inesperado"
    },
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "noAccount": "¿No tienes una cuenta?",
    "signUp": "Regístrate"
  },
  "invitation": {
    "title": "Completa Tu Registro",
    "description": "Establece tu contraseña para activar tu cuenta",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "passwordPlaceholder": "Ingresa tu contraseña",
    "confirmPassword": "Confirmar Contraseña",
    "confirmPasswordPlaceholder": "Confirma tu contraseña",
    "button": "Establecer Contraseña y Activar",
    "button.loading": "Configurando...",
    "invalidTitle": "Invitación Inválida",
    "goToLogin": "Ir a Iniciar Sesión",
    "resetPassword": {
      "title": "Restablecer Tu Contraseña",
      "description": "Ingresa una nueva contraseña para tu cuenta",
      "button": "Restablecer Contraseña",
      "button.loading": "Restableciendo..."
    },
    "error": {
      "noToken": "No se proporcionó token de invitación",
      "invalidToken": "Token de invitación inválido o expirado",
      "passwordLength": "La contraseña debe tener al menos 8 caracteres",
      "passwordMismatch": "Las contraseñas no coinciden",
      "failed": "Error al establecer contraseña. Por favor intenta de nuevo."
    }
  },
  "profile": {
    "title": "Mi Cuenta",
    "subtitle": "Gestiona tu perfil y configuración de seguridad",
    "edit": "Editar",
    "verified": "Verificado",
    "updateSuccess": "Perfil actualizado correctamente",
    "updateError": "Error al actualizar el perfil",
    "info": {
      "title": "Información del Perfil",
      "description": "Los detalles de tu cuenta"
    },
    "field": {
      "name": "Nombre Completo",
      "username": "Nombre de Usuario",
      "email": "Correo Electrónico",
      "memberSince": "Miembro Desde"
    },
    "editModal": {
      "title": "Editar Perfil",
      "description": "Actualiza la información de tu perfil"
    },
    "security": {
      "title": "Cambiar Contraseña",
      "description": "Actualiza tu contraseña para mantener tu cuenta segura",
      "currentPassword": "Contraseña Actual",
      "newPassword": "Nueva Contraseña",
      "confirmPassword": "Confirmar Nueva Contraseña",
      "passwordMismatch": "Las contraseñas no coinciden",
      "passwordInvalid": "La contraseña no cumple los requisitos",
      "changeSuccess": "Contraseña cambiada correctamente. Las demás sesiones han sido cerradas.",
      "changeError": "Error al cambiar la contraseña",
      "changeButton": "Cambiar Contraseña"
    },
    "sessions": {
      "currentSession": "Sesión Actual",
      "current": "Actual",
      "device": "Dispositivo",
      "ip": "Dirección IP",
      "lastActive": "Última Actividad",
      "now": "Ahora",
      "unknown": "Desconocido",
      "otherSessions": "Otras Sesiones",
      "otherDescription": "Sesiones activas en otros dispositivos",
      "revokeAll": "Revocar Todas",
      "revoke": "Revocar",
      "revokeSuccess": "Sesión revocada correctamente",
      "revokeError": "Error al revocar la sesión",
      "revokeAllSuccess": "Todas las demás sesiones han sido cerradas",
      "revokeAllError": "Error al revocar las sesiones",
      "noOtherSessions": "No hay otras sesiones activas",
      "lastActiveAt": "Última actividad {{time}}",
      "neverActive": "Nunca activa",
      "confirmRevokeAll": {
        "title": "Revocar Todas las Sesiones",
        "description": "Esto cerrará sesión en todos los demás dispositivos. Permanecerás conectado en este dispositivo."
      },
      "time": {
        "daysAgo": "hace {{count}} d",
        "hoursAgo": "hace {{count}} h",
        "justNow": "justo ahora",
        "minutesAgo": "hace {{count}} min"
      },
      "unknownBrowser": "Navegador desconocido",
      "unknownDevice": "Dispositivo desconocido"
    }
  },
  "settings": {
    "title": "Ajustes",
    "subtitle": "Gestiona las preferencias de tu aplicación",
    "theme": "Tema",
    "themeDescription": "Selecciona tu tema preferido",
    "language": "Idioma",
    "languageDescription": "Selecciona tu idioma preferido"
  },
  "users": {
    "title": "Usuarios",
    "button": {
      "add": "Agregar Usuario",
      "resetPassword": "Restablecer Contraseña",
      "resendInvitation": "Reenviar Invitación",
      "deactivate": "Desactivar",
      "activate": "Activar",
      "demoteFromAdmin": "Quitar rol de Administrador",
      "promoteToAdmin": "Promover a Administrador"
    },
    "table": {
      "username": "Nombre de usuario",
      "email": "Correo electrónico",
      "name": "Nombre",
      "role": "Rol",
      "status": "Estado",
      "lastLogin": "Último Inicio de Sesión",
      "created": "Creado",
      "actions": "Acciones",
      "noResults": "No se encontraron usuarios",
      "roles": "Roles"
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "date": {
      "never": "Nunca"
    },
    "actions": {
      "label": "Acciones",
      "copyId": "Copiar ID de usuario",
      "editUser": "Editar usuario",
      "openMenu": "Abrir menú",
      "viewDetails": "Ver detalles"
    },
    "filter": {
      "allRoles": "Todos los Roles",
      "allStatus": "Todos los Estados"
    },
    "search": {
      "placeholder": "Buscar por nombre de usuario..."
    },
    "error": {
      "create": "Error al crear usuario",
      "delete": "Error al desactivar usuario",
      "resetPassword": "Error al restablecer contraseña",
      "resendInvitation": "Error al reenviar la invitación",
      "activate": "Error al activar usuario",
      "demote": "Error al quitar el rol al usuario",
      "promote": "Error al promover al usuario"
    },
    "role": {
      "USER": "Usuario",
      "ADMIN": "Administrador",
      "SUPERADMIN": "Super Administrador"
    },
    "modal": {
      "add": {
        "title": "Agregar Nuevo Usuario",
        "description": "Crea una nueva cuenta de usuario. Se generará un enlace de invitación.",
        "name": "Nombre",
        "namePlaceholder": "Ingresa el nombre completo...",
        "email": "Correo electrónico",
        "emailPlaceholder": "Ingresa el correo...",
        "emailOptional": "Correo electrónico (opcional)",
        "identifierHint": "Introduce un nombre de usuario, un correo o ambos — el usuario inicia sesión con lo que establezcas.",
        "username": "Nombre de usuario",
        "usernamePlaceholder": "Ingresa nombre de usuario...",
        "role": "Rol",
        "password": "Contraseña (opcional)",
        "passwordPlaceholder": "Deja vacío para enviar enlace de invitación",
        "passwordHint": "Si se deja vacío, se generará un enlace de invitación para que el usuario establezca su propia contraseña.",
        "button": "Crear Usuario",
        "rolePlaceholder": "Selecciona un rol"
      },
      "invitation": {
        "title": "Enlace de Invitación",
        "message": "Comparte este enlace con el usuario para completar su registro.",
        "emailSent": "La invitación fue enviada por correo a {{email}}.",
        "emailFailed": "No se pudo enviar la invitación por correo a {{email}}. Comparte el enlace de abajo manualmente.",
        "button": {
          "copy": "Copiar Enlace",
          "done": "Hecho"
        }
      },
      "deactivate": {
        "title": "Desactivar Usuario",
        "message": "¿Estás seguro de que deseas desactivar a {username}?",
        "button": "Desactivar"
      },
      "selfReset": {
        "title": "Restablecer Tu Contraseña",
        "message": "Estás a punto de restablecer tu propia contraseña. Serás desconectado y necesitarás usar el enlace de invitación para volver a iniciar sesión.",
        "button": "Restablecer Contraseña"
      },
      "button": {
        "cancel": "Cancelar"
      }
    },
    "card": {
      "total": "en total"
    },
    "pagination": {
      "of": "de",
      "page": "Página",
      "rowsPerPage": "Filas por página"
    }
  },
  "counters": {
    "title": "Contadores",
    "description": "Gestiona tus contadores",
    "newCounter": "Nuevo Contador",
    "empty": "Aún no hay contadores. ¡Crea uno para comenzar!",
    "lastUpdated": "Última actualización:",
    "modal": {
      "title": "Crear Nuevo Contador",
      "description": "Ingresa un nombre para tu nuevo contador.",
      "nameLabel": "Nombre del Contador",
      "namePlaceholder": "Ingresa el nombre del contador...",
      "cancel": "Cancelar",
      "create": "Crear"
    },
    "clearAll": "Borrar Todo",
    "clearAllModal": {
      "cancel": "Cancelar",
      "confirm": "Eliminar Todo",
      "description": "¿Seguro que quieres eliminar los {{count}} contadores? Esta acción no se puede deshacer.",
      "title": "Borrar Todos los Contadores"
    },
    "error": {
      "create": "Error al crear el contador",
      "decrement": "Error al decrementar el contador",
      "delete": "Error al eliminar el contador",
      "deleteAll": "Error al eliminar todos los contadores",
      "increment": "Error al incrementar el contador",
      "reset": "Error al reiniciar el contador"
    },
    "loadError": "No se pudieron cargar los contadores.",
    "noResults": "Ningún contador coincide con tu búsqueda.",
    "search": "Buscar contadores...",
    "toast": {
      "incremented": "Contador incrementado"
    },
    "total": "en total"
  },
  "activity": {
    "table": {
      "timestamp": "Marca de Tiempo",
      "action": "Acción",
      "entityType": "Tipo de Entidad",
      "user": "Usuario",
      "ip": "Dirección IP",
      "status": "Estado",
      "noResults": "No se encontraron registros de actividad"
    },
    "status": {
      "success": "Éxito",
      "failed": "Fallido"
    },
    "filter": {
      "clear": "Limpiar",
      "allActions": "Todas las Acciones",
      "allEntities": "Todos los Tipos de Entidad",
      "allStatus": "Todos los Estados"
    },
    "entityType": {
      "session": "Sesión",
      "user": "Usuario",
      "counter": "Contador"
    },
    "action": {
      "LOGIN": "Inicio de Sesión",
      "LOGIN_FAILED": "Inicio Fallido",
      "LOGOUT": "Cierre de Sesión",
      "LOGOUT_ALL": "Cerrar Todas",
      "TOKEN_REFRESH": "Renovar Token",
      "CREATE": "Crear",
      "UPDATE": "Actualizar",
      "DELETE": "Eliminar",
      "PASSWORD_SET": "Contraseña Establecida",
      "PASSWORD_CHANGE": "Cambio de Contraseña",
      "PASSWORD_RESET": "Restablecer Contraseña",
      "REGISTER": "Registro",
      "EMAIL_VERIFY": "Verificar Email",
      "VIEW": "Consulta",
      "RESEND_VERIFICATION": "Reenviar Verificación"
    },
    "search": {
      "placeholder": "Buscar por nombre de usuario, IP, entidad..."
    },
    "button": {
      "details": "Detalles"
    },
    "modal": {
      "title": "Detalles de Actividad"
    },
    "details": {
      "error": "Error",
      "previousState": "Estado Anterior",
      "newState": "Nuevo Estado",
      "metadata": "Metadatos",
      "userAgent": "Agente de Usuario"
    },
    "pagination": {
      "of": "de",
      "page": "Página",
      "rowsPerPage": "Filas por página"
    }
  },
  "activityHistory": {
    "title": "Historial de Actividad",
    "description": "Ver registros de auditoría del sistema y actividad del usuario",
    "card": {
      "total": "registros"
    }
  },
  "toast": {
    "sessionExpired": "Sesión expirada. Por favor inicia sesión de nuevo.",
    "deviceMismatch": "Esta sesión pertenece a otro dispositivo. Por favor inicia sesión de nuevo.",
    "rateLimited": "Demasiadas solicitudes. Por favor intenta de nuevo más tarde.",
    "reconnecting": "Reconectando…",
    "unreachable": "No pudimos conectar con el servidor — puede estar reiniciándose. No se guardó nada; inténtalo de nuevo en un momento."
  },
  "backend": {
    "accountLocked": "Demasiados intentos fallidos. Inténtalo de nuevo en {{seconds}} segundos",
    "accountLockedTitle": "Cuenta bloqueada temporalmente",
    "badRequest": "La solicitud no es válida",
    "cannotAssignCustomerRole": "El rol de Cliente no se puede asignar a usuarios gestionados por administradores",
    "cannotDeactivateOwnAccount": "No puedes desactivar tu propia cuenta",
    "cannotDeleteOwnAccount": "No puedes eliminar tu propia cuenta",
    "cannotDeleteSuperAdmin": "Los usuarios Super Administradores no se pueden eliminar",
    "cannotModifyOwnRoles": "No puedes modificar tus propios roles",
    "cannotModifyOwnSuperAdmin": "No puedes modificar tu propio estado de Super Administrador",
    "cannotResendSuperAdminInvitation": "No se pueden reenviar invitaciones a usuarios Super Administradores",
    "cannotResetSuperAdminPassword": "La contraseña de un Super Administrador no se puede restablecer aquí",
    "cannotUpdateSuperAdmin": "Los usuarios Super Administradores no se pueden modificar",
    "conflict": "Esto ya existe",
    "counterNotFound": "Contador no encontrado",
    "currentPasswordIncorrect": "La contraseña actual es incorrecta",
    "emailAlreadyVerified": "Este correo electrónico ya está verificado. Puedes iniciar sesión.",
    "emailExists": "Este correo electrónico ya está registrado",
    "emailNotVerified": "Verifica tu correo electrónico antes de iniciar sesión",
    "emailRequired": "El correo electrónico es obligatorio",
    "fetchActivityFailed": "No se pudo cargar la actividad",
    "fetchProfileFailed": "No se pudo cargar tu perfil",
    "fetchSessionsFailed": "No se pudieron cargar tus sesiones",
    "fetchUsersFailed": "No se pudieron cargar los usuarios",
    "forbidden": "No tienes permiso para hacer eso",
    "identifierInUse": "Ese nombre de usuario o correo electrónico ya está en uso",
    "identifierRequired": "El nombre de usuario o correo electrónico es obligatorio",
    "invalidCredentials": "Nombre de usuario o contraseña incorrectos",
    "invalidEmail": "Formato de correo electrónico no válido",
    "invalidInvitationToken": "Enlace de invitación inválido o expirado",
    "invalidResetToken": "Este enlace para restablecer la contraseña no es válido o ha expirado",
    "invalidVerificationToken": "Este enlace de verificación no es válido o ha expirado",
    "logoutAllFailed": "No se pudieron cerrar las demás sesiones",
    "logoutFailed": "Error al cerrar sesión",
    "newPasswordSameAsCurrent": "La nueva contraseña debe ser diferente de la actual",
    "noPlatformAccess": "Tu cuenta no tiene acceso a esta aplicación",
    "notFound": "No encontrado",
    "onlySuperAdminsCreateSuperAdmins": "Solo los Super Administradores pueden crear usuarios Super Administradores",
    "onlySuperAdminsManageSuperAdmins": "Solo los Super Administradores pueden gestionar el estado de Super Administrador",
    "passwordAlreadySet": "Este usuario ya estableció una contraseña. Usa el restablecimiento de contraseña.",
    "passwordComplexity": "La contraseña no cumple los requisitos",
    "passwordMinLength": "La contraseña debe tener al menos {{count}} caracteres",
    "passwordNotSet": "Esta cuenta no tiene una contraseña establecida",
    "passwordSetupRequired": "Debes establecer tu contraseña antes de iniciar sesión",
    "profileNotFound": "Perfil no encontrado",
    "registrationFailed": "Error en el registro",
    "registrationUnavailable": "El registro no está disponible",
    "resetPasswordFailed": "Error al restablecer la contraseña",
    "revokeSessionFailed": "No se pudo revocar la sesión",
    "securityCheckFailed": "Falló la comprobación de seguridad. Recarga la página e inténtalo de nuevo.",
    "serverError": "Algo salió mal de nuestro lado. Inténtalo de nuevo.",
    "sessionNotFound": "Sesión no encontrada",
    "tooManyLoginAttempts": "Demasiados intentos de inicio de sesión. Inténtalo de nuevo en {{seconds}} segundos",
    "updateUserFailed": "Error al actualizar el usuario",
    "userNotFound": "Usuario no encontrado",
    "usernameDerivedFromEmail": "El nombre de usuario se deriva del correo electrónico cuando el inicio de sesión es por correo",
    "usernameExists": "El nombre de usuario ya existe",
    "usernameRequired": "El nombre de usuario es obligatorio",
    "verificationFailed": "Verificación fallida",
    "verificationUnavailable": "La verificación de correo electrónico no está disponible",
    "verifyInvitationFailed": "No se pudo verificar la invitación",
    "accountDeactivated": "La cuenta está desactivada",
    "accountLockedFor": "Cuenta bloqueada durante {{seconds}} segundos",
    "invalidPassword": "Contraseña incorrecta",
    "invalidPasswordLocked": "Contraseña incorrecta – cuenta bloqueada durante {{seconds}} segundos",
    "passwordPolicyDefault": "La contraseña debe contener mayúsculas, minúsculas, un número y un carácter especial",
    "platformAccessDenied": "Acceso denegado para esta plataforma ({{platform}})",
    "sendVerificationFailed": "No se pudo enviar el correo de verificación"
  },
  "dataTable": {
    "clearFilters": "Limpiar filtros",
    "columns": "Columnas",
    "noResults": "Sin resultados.",
    "pagination": {
      "next": "Siguiente",
      "pageOf": "Página {{page}} de {{pageCount}}",
      "perPage": "{{count}} / página",
      "previous": "Anterior",
      "showing": "Mostrando {{from}} a {{to}} de {{total}} resultados"
    },
    "rowsSelected": "{{selected}} de {{total}} fila(s) seleccionada(s).",
    "searchPlaceholder": "Buscar...",
    "column": {
      "actions": "Acciones",
      "createdAt": "Creado",
      "isActive": "Estado",
      "lastLoginAt": "Último Acceso",
      "name": "Nombre",
      "roles": "Roles",
      "username": "Nombre de usuario"
    }
  },
  "forgotPassword": {
    "backToLogin": "Volver a iniciar sesión",
    "description": "Ingresa tu correo electrónico y te enviaremos un enlace para restablecerla.",
    "email": "Correo electrónico",
    "emailPlaceholder": "Ingresa tu correo electrónico",
    "sent": {
      "description": "Si existe una cuenta con este correo electrónico, recibirás un enlace para restablecer la contraseña.",
      "title": "Revisa tu correo electrónico"
    },
    "submit": "Enviar Enlace",
    "title": "Olvidé mi Contraseña"
  },
  "password": {
    "error": {
      "complexity": "La contraseña no cumple los requisitos",
      "minLength": "La contraseña debe tener al menos {{count}} caracteres"
    },
    "requirement": {
      "complexity": "Cumple los requisitos de complejidad",
      "minLength": "Al menos {{count}} caracteres"
    }
  },
  "register": {
    "button": "Crear cuenta",
    "button.loading": "Creando cuenta...",
    "confirmPassword": {
      "label": "Confirmar Contraseña",
      "placeholder": "Confirma tu contraseña"
    },
    "description": "Ingresa tus datos para crear tu cuenta",
    "email": {
      "label": "Correo electrónico",
      "placeholder": "Ingresa tu correo electrónico"
    },
    "error": {
      "failed": "Error en el registro. Inténtalo de nuevo.",
      "invalidEmail": "Ingresa un correo electrónico válido",
      "nameRequired": "El nombre es obligatorio",
      "passwordLength": "La contraseña debe tener al menos 8 caracteres",
      "passwordMismatch": "Las contraseñas no coinciden"
    },
    "hasAccount": "¿Ya tienes una cuenta?",
    "name": {
      "label": "Nombre",
      "placeholder": "Ingresa tu nombre"
    },
    "password": {
      "label": "Contraseña",
      "placeholder": "Ingresa tu contraseña"
    },
    "signIn": "Iniciar sesión",
    "success": "¡Registro exitoso! Revisa tu correo electrónico para verificar tu cuenta.",
    "title": "Crea una cuenta"
  },
  "resetPassword": {
    "confirmPassword": "Confirmar Contraseña",
    "description": "Ingresa tu nueva contraseña a continuación.",
    "error": "Error al restablecer la contraseña",
    "goToLogin": "Ir a Iniciar Sesión",
    "invalid": {
      "description": "Este enlace para restablecer la contraseña ha expirado o no es válido. Solicita uno nuevo.",
      "title": "Enlace Inválido o Expirado"
    },
    "newPassword": "Nueva Contraseña",
    "passwordInvalid": "La contraseña no cumple los requisitos",
    "passwordMismatch": "Las contraseñas no coinciden",
    "requestNew": "Solicitar Nuevo Enlace",
    "submit": "Restablecer Contraseña",
    "success": "Contraseña restablecida correctamente",
    "success.description": "Serás redirigido al inicio de sesión en breve.",
    "success.title": "Contraseña Restablecida",
    "title": "Restablecer Contraseña"
  },
  "verifyEmail": {
    "error": {
      "invalidToken": "Este enlace de verificación no es válido o ha expirado.",
      "noToken": "No se proporcionó un token de verificación",
      "title": "Verificación Fallida"
    },
    "goToLogin": "Ir a Iniciar Sesión",
    "needAccount": "¿No tienes una cuenta?",
    "resend": {
      "button": "Reenviar Correo de Verificación",
      "cancel": "Cancelar",
      "email": {
        "label": "Correo Electrónico",
        "placeholder": "Ingresa tu correo electrónico"
      },
      "emailRequired": "Ingresa tu correo electrónico",
      "sending": "Enviando...",
      "submit": "Enviar",
      "success": "Si tu correo electrónico está registrado, recibirás un correo de verificación."
    },
    "signUp": "Regístrate",
    "success": {
      "description": "Tu correo electrónico ha sido verificado correctamente. Ya puedes iniciar sesión en tu cuenta.",
      "redirect": "Redirigiendo al inicio de sesión...",
      "title": "¡Correo Verificado!"
    }
  }
}
